module.exports = __webpack_public_path__ + "img/value-2.ca14f6d6.svg";